import React, { useEffect, useState, useRef } from 'react';
import { IoClose } from 'react-icons/io5';
import { formatTimestampForLastUpdated } from '../../../../utils/GenericInsightStack';
import { postOnDemandRefreshReport } from '../../../../service/ApiList';
import { useNavigate } from 'react-router-dom';

function OnDemandScreen({ handleCloseModal, lastUpdated, handleOnDemandRefreshLoading }) {
  const navigate = useNavigate();
  useEffect(() => {
    if (getRemainingDaysInfo(lastUpdated).remainingDays <= 0) {
      // postOnDemandRefreshReport((res) => {
      //   if (res.data.success) {
      //     handleOnDemandRefreshLoading(true)
      //     handleCloseModal();
      //   } else {
      //     localStorage.setItem("StatusLS", "BUREAU_DELETED");
      //     localStorage.removeItem("loginConfirm")
      //     navigate("/login/user", { state: { isRefreshReport: true } })
      //     handleCloseModal();
      //   }
      // })
    } else {
      console.log("No")
    }
  }, []);


  const handleClose = () => {
    handleCloseModal();
  };

  const getRemainingDaysInfo = (timestamp) => {
    const inputDate = new Date(timestamp);

    const nextMonth = inputDate.getMonth() + 1;
    const nextYear = inputDate.getFullYear() + (nextMonth > 11 ? 1 : 0);
    const nextMonthIndex = nextMonth % 12;
    // Set date to 1st of next month
    const nextDate = new Date(nextYear, nextMonthIndex, 1);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    nextDate.setHours(0, 0, 0, 0);
    const diffTime = nextDate - today;
    const remainingDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return {
      nextDate: nextDate.toLocaleDateString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      }),
      remainingDays: remainingDays > 0 ? remainingDays : 0,
    };
  };


  return (
    <div className="call-me-back-main">
      <>
        <p style={{ maxWidth: 450 }}>
          {/*  April 2nd.   */}
          Your last report was updated on {formatTimestampForLastUpdated(lastUpdated)}.  {' '}
          {getRemainingDaysInfo(lastUpdated).remainingDays > 0 ? <>
            Your next complimentary credit report will be available from  {' '}
            {getRemainingDaysInfo(lastUpdated).nextDate}  {' '}
            onwards.
          </> : null}
        </p>
        {
          getRemainingDaysInfo(lastUpdated).remainingDays > 0
            ?
            <button onClick={handleClose}>Close <IoClose /></button>
            :
            null
        }
      </>
    </div>
  );
}

export default OnDemandScreen;
